import { render, staticRenderFns } from "./AuthorProfit.vue?vue&type=template&id=259d9840&"
import script from "./AuthorProfit.vue?vue&type=script&lang=js&"
export * from "./AuthorProfit.vue?vue&type=script&lang=js&"
import style0 from "./AuthorProfit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports